/** Shared gate field rules, used by the form and the lead route. */
export const GATE_EMAIL_ERROR = "Enter a valid work email";
export const GATE_MOBILE_ERROR = "Enter an Australian mobile, for example 0412 345 678";

export function normaliseAuMobile(raw: string): string | null {
  const s = raw.replace(/[\s()\-.]/g, "");
  let d: string;
  if (/^\+614\d{8}$/.test(s)) d = "0" + s.slice(3);
  else if (/^04\d{8}$/.test(s)) d = s;
  else return null;
  return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`;
}

export const isEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) && v.trim().length <= 255;
